import { render, staticRenderFns } from "./chi-siamoPage.vue?vue&type=template&id=680d0688&"
import script from "./chi-siamoPage.vue.ts?vue&type=script&lang=ts&"
export * from "./chi-siamoPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports